import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Input, notification, Select, Upload } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import Title from "antd/lib/skeleton/Title";
import { Formik } from "formik";
import React, { useContext, useEffect } from "react";
import { Persona, PersonaPresence, PersonaSize } from "@fluentui/react";
import { observer } from "mobx-react-lite";
import HomeStore from "../../home/store/homestore";
import ProfileStore from "../store/profilestore";
import { toJS } from "mobx";
const { Option } = Select;
const _ = require("underscore");
export const BasicSettingsView = observer(() => {
  const homeStore = useContext(HomeStore);
  const profileStore = useContext(ProfileStore);

  useEffect(() => {
    async function getInitialdata() {
      try {
        if (!homeStore.loadedinitdata) {
          await homeStore.getInitialData();
        }
        await profileStore.getUserProfile();
      } catch (error) {
        if (!error.response) {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description:
              "SPARS Backend Server is not reachable, please contact SPARS support",
          });
        } else {
          notification.error({
            key: "error",
            message: "SPARS Feedback",
            description: error.message,
          });
        }
      }
    }
    getInitialdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const styles = {
    top: {
      paddingTop: "8px",
      paddingRight: "40px",
      paddingBottom: "8px",
      paddingLeft: "40px",
    },
    title: {
      marginBottom: "12px",
      color: "rgba(0,0,0,.85)",
      fontWeight: "500",
      fontSize: "20px",
      lineHeight: "28px",
    },

    button_view: {
      width: "144px",
      textAlign: "center",
    },
    baseView: {
      display: "flex",
      paddingTop: "12px",
    },
    left: {
      minWidth: "224px",
      maxWidth: "448px",
    },
  };
  const AvatarView = ({ profile }) => (
    <>
      <div className={styles.avatar}></div>
      <Upload showUploadList={false}>
        <div className={styles.button_view}>
          <Persona
            text={profile?.fullName}
            secondaryText={profile?.jobFunction}
            optionalText={profile?.company}
            presence={PersonaPresence.online}
            size={PersonaSize.size100}
          />
        </div>
      </Upload>
    </>
  );

  return (
    <div className="ms-Grid" dir="ltr" style={styles.top}>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <span style={styles.title}>Basic Profile Settings</span>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm4">
          {" "}
          <Formik
            enableReinitialize={true}
            // isInitialValid={true}
            initialValues={toJS(profileStore.userprofile?.profile)}
            // validationSchema={AccountRequestValidationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                profileStore.isSaving = true;
                const retVal = await profileStore.updateUserProfile(values);
                if (retVal.success) {
                  notification.success({
                    message: "SPARS Feedback",
                    description: "basic profile modifications successfull",
                  });
                  profileStore.selectKey = "2";
                  profileStore.userprofile.profile = { ...values };
                }
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                profileStore.isSaving = false;
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,

              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form layout="vertical" onFinish={handleSubmit}>
                <Title level={5}>New Request Information</Title>

                <FormItem
                  label="First Name"
                  required
                  help={touched.firstName && errors.firstName}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: "#A0AEC0" }} />}
                    value={values?.firstName}
                    name="firstname"
                    onChange={handleChange}
                    allowClear
                  />
                </FormItem>

                <FormItem
                  label="Last Name"
                  required
                  help={touched.lastName && errors.lastName}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: "#A0AEC0" }} />}
                    value={values?.lastName}
                    onChange={handleChange}
                    name="lastname"
                    allowClear
                  />
                </FormItem>

                <FormItem
                  label="Job Title"
                  required
                  help={touched.jobFunction && errors.jobFunction}
                >
                  <Input
                    value={values?.jobFunction}
                    onChange={handleChange}
                    allowClear
                    name="jobfunction"
                  />
                </FormItem>

                <FormItem
                  label="Department"
                  required
                  help={touched.departmentId && errors.departmentId}
                >
                  <Select
                    placeholder="Select your department"
                    name="department"
                    value={values?.departmentId}
                    onChange={(val) => {
                      setFieldValue("departmentId", val, false);
                    }}
                  >
                    {_.sortBy(homeStore.departments, "departmentName").map(
                      (dept) => (
                        <Option
                          value={dept.departmentId}
                          key={dept.departmentId}
                        >
                          <div
                            style={{
                              display: "flex",

                              justifyContent: "space-between",
                            }}
                          >
                            <div>{dept.departmentName}</div>
                            <div className="pill">{dept.code}</div>
                          </div>
                        </Option>
                      )
                    )}
                  </Select>
                </FormItem>

                <FormItem label="Personal profile">
                  <Input.TextArea
                    placeholder="Brief introduction to yourself"
                    rows={4}
                    name="persoanlProfile"
                    value={values?.persoanlProfile}
                    onChange={handleChange}
                    allowClear
                  />
                </FormItem>

                <FormItem label="Office Extension">
                  <Input
                    placeholder="Enter a valid office extension or phone number"
                    prefix={<PhoneOutlined style={{ color: "#A0AEC0" }} />}
                    value={values?.extension}
                    onChange={handleChange}
                    name="extension"
                    allowClear
                  />
                </FormItem>

                <FormItem
                  label="Employee Category"
                  required
                  help={touched.userType && errors.userType}
                >
                  <Select
                    defaultValue={values?.userType}
                    value={values?.userType}
                    name="userType"
                    onChange={(val) => {
                      setFieldValue("userType", val, false);
                    }}
                  >
                    {["Staff", "Contractor"].map((s) => (
                      <Option value={s} key={s}>
                        {s}
                      </Option>
                    ))}
                  </Select>
                </FormItem>

                <FormItem label="office Location">
                  <Input
                    value={values?.officeLocation}
                    name="officeLocation"
                    placeholder="Your office location here"
                    onChange={handleChange}
                    allowClear
                  />
                </FormItem>
                <FormItem style={{ paddingTop: "20px", textAlign: "right" }}>
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={profileStore.isSaving}
                  >
                    Update Information
                  </Button>
                </FormItem>
              </Form>
            )}
          </Formik>
        </div>
        <div className="ms-Grid-col ms-sm8">
          <AvatarView profile={toJS(profileStore.userprofile?.profile)} />
        </div>
      </div>
    </div>
  );
});

